/* ==========================================================================
   InputRxjs > Client > Prototype
   ========================================================================== */

/* Modules */
const { Store } = require('@bluekiri/alexandria/helpers/state');

const { fromEvent } = require('rxjs');
const { fromFetch } = require('rxjs/fetch');
const { take } = require('rxjs/operators');

const { actions, types } = require('./store/actions');
const { reducer } = require('./store/reducer');

/* Prototype */
const prototype = {
    /* Setup store */
    setupStore() {
        if (this.store) return this;

        this.store = new Store({
            image: reducer
        });

        return this;
    },
    /* Setup actions */
    setupActions() {
        if (this.actions) return this;

        this.actions = {
            destroy: () => this.store.dispatch(actions.destroy()),
            display: () => this.store.dispatch(actions.display()),
            hide: () => this.store.dispatch(actions.hide()),
            setSrc: src => this.store.dispatch(actions.setSrc(src))
        };

        return this;
    },
    /* Setup reactions */
    setupReactions() {
        if (this.reactions) return this;

        this.reactions = {
            destroy: this.store.subscribe((state, action) => {
                if (action.type !== types.DESTROY) return;

                /* Unsubscribe */
                this.unsubscribe();

                /* Remove from DOM */
                this.element.parentNode.removeChild(this.element);

                /* Clean instance */
                [...Object.keys(this)].forEach(key => delete this[key]);
            }),
            display: this.store.subscribe((state, action) => {
                if (action.type !== types.DISPLAY) return;

                const { css } = this.config;
                this.element.classList.remove(css.hidden);
            }),
            hide: this.store.subscribe((state, action) => {
                if (action.type !== types.HIDE) return;

                const { css } = this.config;
                this.element.classList.add(css.hidden);
            }),
            setSrc: this.store.subscribe((state, action) => {
                if (action.type !== types.SET_SRC) return;

                const { loaded } = state.image;

                if (loaded) return;

                /* Set src to the img element */
                this.hooks.img.src = action.payload;
            })
        };

        return this;
    },
    /* Subscribe */
    subscribe() {
        if (this.subscriptions) this.unsubscribe();

        this.subscriptions = {
            lazyLoad: fromEvent(this.hooks.img, 'lazyloaded')
                .pipe(take(1))
                .subscribe(() => {
                    const { src } = this.hooks.img.dataset;

                    /* Dispatch action */
                    this.actions.setSrc(src);
                }),
            error: fromEvent(this.hooks.img, 'error')
                .pipe(take(1))
                .subscribe(() => {
                    const { alternative } = this.hooks.img.dataset;

                    this.hooks.img.src = alternative;
                })
        };

        return this;
    },
    /* Unsubscribe */
    unsubscribe() {
        if (!this.subscriptions) return this;

        [...Object.keys(this.subscriptions)].forEach(key => this.subscriptions[key].unsubscribe());

        return this;
    },
    /* Start */
    start() {
        const { isLazy = true, css, alternative } = this.config;

        if (isLazy) this.hooks.img.classList.add(css.load);

        if (!isLazy) {
            fromFetch(this.hooks.img.src)
                .pipe(take(1))
                .subscribe(data => {
                    if (data.status === 404 && alternative) {
                        this.hooks.img.src = alternative;
                    }
                });
        }
    },
    /* Init */
    init() {
        /* Setup store */
        this.setupStore();

        /* Setup actions */
        this.setupActions();

        /* Setup reactions */
        this.setupReactions();

        /* Subscribe */
        this.subscribe();

        /* Requier library */
        module.require('lazysizes');

        /* Start */
        if (this.config.start) this.start();
    }
};

/* Exports */
module.exports = prototype;
